export default __webpack_public_path__ + "static/media/funOuter.4c500b4f.webp";